<template>
  <create-page
    :aspect-menu-items="aspectMenuItems"
    :errors="errors"
    :meta="meta"
    :model="model"
    :resource-type="resourceType"
    :toasts="toasts"
  >
  </create-page>
</template>

<script>
import CreatePage from '@/structures/default/Pages/Models/Create';

export default {
  components: {
    CreatePage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    resourceType: { type: String, default: '' },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
